module.exports = __webpack_public_path__ + "static/UNITY-Square-One-5th-floor-modern_v2-e01151d34add46b0510e79e90e3cbed4.pdf";